import { render, staticRenderFns } from "./SuccessStory.vue?vue&type=template&id=2dfd723a"
import script from "./SuccessStory.vue?vue&type=script&lang=js"
export * from "./SuccessStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrismicSlice: require('/home/runner/work/marketing/marketing/components/PrismicSlice.vue').default})
